import React from "react";
import styles from "./PeopleUI.module.css";
import Avatar from "../../../components/common/Avatar";
import EmptyContact from "./EmptyContact";
import WeekBar from "./WeekBar";
import { getRoleVariant } from "./roleVariant";

const VARIANT_CLASS = {
  owner: styles.roleOwner,
  employee: styles.roleEmployee,
  contractor: styles.roleContractor,
  invited: styles.roleInvited,
  role: styles.roleRole,
};

// A div acting as a button: the selection tickbox inside can't be nested in a real <button>.
export default function PersonCompactCard({ employee, onClick, onAddContactInfo, selectable, selected, onToggleSelect }) {
  const variant = getRoleVariant(employee);
  const isInvited = variant === "invited";
  const isContractor = variant === "contractor";

  const accentClass = VARIANT_CLASS[variant] || styles.roleNeutral;

  const email = employee.email || "";
  const phone = employee.phone_number || employee.phone || "";
  const jobTitle = employee.job_title || "";
  const hasContact = !!(email || phone);

  const metaPrimary = email || phone;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.target !== e.currentTarget || (e.key !== "Enter" && e.key !== " ")) return;
        e.preventDefault();
        onClick?.();
      }}
      className={`${styles.personCard} ${accentClass} ${selected ? styles.cardSelected : ""}`}
      aria-label={employee.name}
    >
      <Avatar
        name={employee.name}
        imageUrl={employee.avatar_url}
        size="sm"
        variant={isContractor ? "contractor" : "default"}
      />
      <div className={styles.personCardBody}>
        <span className={styles.personCardName}>{employee.name}</span>
        {hasContact ? (
          <span className={styles.personCardMeta}>
            {jobTitle ? `${jobTitle} · ` : ""}{metaPrimary}
          </span>
        ) : (
          <EmptyContact employee={employee} onAddContactInfo={onAddContactInfo} />
        )}
      </div>
      <div className={styles.personCardRight}>
        {isInvited && <span className={styles.personCardInvitedTag}>Invited</span>}
        {selectable && (
          <input
            type="checkbox"
            className={styles.cardSelect}
            checked={!!selected}
            onChange={onToggleSelect}
            onClick={(e) => e.stopPropagation()}
            aria-label={`Select ${employee.name}`}
          />
        )}
      </div>
      {!isInvited && (
        <div className={styles.personCardFooter}>
          <WeekBar booked={employee.week_booked_hours} capacity={employee.default_weekly_hours} />
        </div>
      )}
    </div>
  );
}
